import $ from 'jquery';
import {
	createEngagementCommentParent,
	updateEngagementCommentEntity,
	createEngagementCommentReply
} from '../../../../actions/EngagementComments/engagementcommentactions';
import {EngagementCommentInputModalModes, clientSideEventNames, formBodyType, CardTypes, EngagementCommentStatus} from '../../../../util/uiconstants';
import Utility from '../../../../util/utilityfunctions';

const maxCommentLength = 4000;

const validCardTypes = [CardTypes.DefaultView, CardTypes.CardView, CardTypes.CardViewTop];

// Body types in which the comments icon is not shown (standard view)
const invalidBodyTypes = [formBodyType.Spacer];

// Body types in which the comments icon is not shown (summary view)
const invalidSummaryBodyTypes = [...invalidBodyTypes];

function applyFilter(comments, filter) {
	let filteredComments = comments;

	if (filter) {
		filteredComments = [];

		comments &&
			comments.map((c) => {
				if (filter(c)) {
					filteredComments.push(c);
				}
			});
	}

	return Utility.normalize(filteredComments, undefined, 'engagementCommentGuid');
}

export const validCommentStatuses = [EngagementCommentStatus.open, EngagementCommentStatus.cleared];

export function validate(comment, isRecordingInprogress, voiceData, screenData, isScreenRecordDataRemoved = false, isVoiceDataRemoved = false) {
	let valid = true;

	if (comment) {
		if (!comment.isChild) {
			valid = valid && validateAssignedTo(comment.assignedToUserId);
			valid = valid && validatePriority(comment.priorityTypeId);
			valid = valid && validateDueDate(comment.dueDate);
		}
		valid =
			valid &&
			(validateText(comment.commentText) ||
				(!isVoiceDataRemoved && validateVoiceNote(voiceData)) ||
				(!isScreenRecordDataRemoved && validateScreenRecording(screenData)));
	} else {
		valid = false;
	}

	return valid;
}

export function save(comment, mode, commentsStateKey) {
	if (mode === EngagementCommentInputModalModes.create) {
		if (comment.content.isChild) {
			return createEngagementCommentReply(comment.engagementId, comment.content, comment.isGuest, comment.documentId, comment.documentTypeId, {
				commentsStateKey
			});
		} else {
			return createEngagementCommentParent(comment.engagementId, comment.content, comment.isGuest, comment.documentId, comment.documentTypeId, {
				commentsStateKey
			});
		}
	} else {
		return updateEngagementCommentEntity(comment.engagementId, comment.content, comment.isGuest, comment.documentId, comment.documentTypeId, true, {
			commentsStateKey
		});
	}
}

export function validateAssignedTo(assignedTo) {
	return assignedTo && assignedTo !== 'undefined' && assignedTo !== null;
}

export function validatePriority(priority) {
	return priority && priority !== 'undefined' && priority !== null;
}

export function validateDueDate(dueDate) {
	return dueDate && dueDate !== 'undefined' && dueDate !== null;
}

export function validateVoiceNote(voiceNote) {
	return voiceNote && voiceNote !== 'undefined' && voiceNote !== null;
}

export function validateScreenRecording(screenData) {
	return screenData && screenData !== 'undefined' && screenData !== null;
}

export function validateText(text) {
	if (typeof text !== 'string') return false;
	const _text = decodeURIComponentSafe(text.trim());
	return _text.length > 0 && _text.length <= maxCommentLength;
}

export function decodeURIComponentSafe(s) {
	if (!s) {
		return s;
	}
	if (s.includes('%')) {
		return decodeURIComponent(s.replace(/%(?![0-9][0-9a-fA-F]+)/g, '%25'));
	} else {
		return decodeURIComponent(s.trim());
	}
}

export function dispatchModalDisplay(isAresView, bodyId, bodyTypeId, documentTypeId, isSummaryView) {
	window.dispatchEvent(new CustomEvent(clientSideEventNames.closeCommentsModal));
	if (isAresView) {
		if (bodyTypeId === formBodyType.TextResponse && !isSummaryView) return;
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.showCommentsModal, {
				detail: {bodyId: bodyId, documentTypeId: documentTypeId, show: true}
			})
		);
	} else if (bodyTypeId !== formBodyType.TextResponse) {
		window.dispatchEvent(
			new CustomEvent(clientSideEventNames.showCommentsModal, {
				detail: {bodyId: bodyId, documentTypeId: documentTypeId, show: true}
			})
		);
	}
	//<StyledCommentsIcon className="comments-icon" id={'commentsIconWrapper-' + bodyModel.id}></StyledCommentsIcon>
	$('span[id^=cmtIcon]').removeClass('active');
	$('#cmtIcon-' + bodyId).addClass('active');
	$('.comments-icon.active').removeClass('active');
	$('#commentsIconWrapper-' + bodyId).addClass('active');
}

export function isActiveComment(comment) {
	return validCommentStatuses.indexOf(comment.engagementCommentStatusId) !== -1;
}

export function isValidCardType(cardTypeId) {
	return validCardTypes.indexOf(cardTypeId) !== -1;
}

export function hasActiveComments(comments) {
	let result = false;
	let index = 0;

	if (comments.allIds.length > 0) {
		do {
			const id = comments.allIds[index];
			const comment = comments.byId[id];

			result = isActiveComment(comment);

			index++;
		} while (!result && index < comments.allIds.length);
	}

	return result;
}

export function isValidBodyType(bodyTypeId, isSummaryView) {
	let validBodyType;

	if (isSummaryView) {
		validBodyType = invalidSummaryBodyTypes.indexOf(bodyTypeId) === -1;
	} else {
		validBodyType = invalidBodyTypes.indexOf(bodyTypeId) === -1;
	}

	return validBodyType;
}

export function getCommentsAmmountBySection(formDataSlice, commentsSlice, sectionId, filter) {
	let count = 0;

	if (formDataSlice?.length > 0) {
		const section = formDataSlice.find((section) => section.sectionId === sectionId);
		if (section?.bodies?.length > 0) {
			for (let i = 0; i < section.bodies.length; i++) {
				const body = section.bodies[i];
				const comments = commentsSelector(formDataSlice, commentsSlice, body.id, filter);
				count += comments.allIds.length;
			}
		}
	}

	return count;
}

export function getCommentsAmmountByHeader(headersSlice, formDataSlice, commentsSlice, headerId, filter) {
	let count = 0;
	const header = headersSlice.byId[headerId];

	if (header.sections?.length > 0) {
		header.sections.map((sectionId) => {
			count += getCommentsAmmountBySection(formDataSlice, commentsSlice, sectionId, filter);
		});
	}

	return count;
}

//We have two sources for comments:
//1) FormData: The comments we get through the formbodies get api (We usually populate the comments counter with this one).
//2) EngagementComments: The updated on demand comments which the user interacts with.
//We are required to sum all bodies active comments (hasActiveComments()) in the same section. Since not all bodies will have this last slice (engagementComments)
//updated with its information on body level, we have to prioritize the ones updated over the ones that come from formData.
export function commentsSelector(formDataSlice, commentsSlice, bodyId, filter) {
	let result;
	const updatedComments = commentsSlice && commentsSlice[bodyId];

	if (updatedComments !== undefined) {
		result = applyFilter(updatedComments, filter);
	} else {
		const section = formDataSlice.find((section) => section?.bodies?.length > 0 && section.bodies.find((body) => body.id === bodyId) !== undefined);
		const formBody = section && section.bodies.find((body) => body.id === bodyId);

		result = applyFilter(formBody && formBody.engagementComments, filter);
	}

	return result;
}
